import React, { Component } from "react";
import { useLocation } from "react-router-dom";
import SimpleReactValidator from "simple-react-validator";
import CUSTOMER_LOGO from "../Utils/StaticData/staticHeader";
import Step1 from "./Step1.jsx";
import Step2_2021 from "./Step2.jsx";
import Step2Category1 from "./step2/Step2Category1.jsx";
import Step2Category2 from "./step2/Step2Category2.jsx";
import Step2Category3 from "./step2/Step2Category3.jsx";
import Step3 from "./Step3.jsx";
import Step4 from "./Step4.jsx";
import Captcha from "./Captcha";
import StepsFooter from "./stepsFooter";
import { INITIAL_STATE } from "./initialState";
import { connect } from "react-redux";
import LinearProgress from "@material-ui/core/LinearProgress";
import { withStyles } from "@material-ui/core/styles";
import Footer1 from "../Utils/GenericUI/Footer1";
import Footer2 from "../Utils/GenericUI/Footer2";
import * as DateUtil from "../Utils/DatePicker";
import { handleDateChange } from "../Utils/DateFormatter";
import {
  saveLogout,
  submitForm,
  getClinicalName,
  removeplan,
  captchaValidation
} from "../Redux/Actions/webAppActions";
import history from "../Utils/History";
import { Text, setLanguage } from "react-internationalization";
import ReactDOMServer from "react-dom/server";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import moment from "moment";
import ReactDOM from "react-dom";
import isEmpty from "lodash/isEmpty";
const styles = (props) => ({
  progressComplete: {
    backgroundColor: "#00695C",
  },
  root: {
    height: "20px",
  },
  progressIncomplete: {
    backgroundColor: "#b8880c",
  },
});
let test = false;
let lang = "en";
class PreEnrollForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stepVal: "step1",
      data: {...INITIAL_STATE},
      // data:
      //  this.props.preEnrollInfo.length === 0
      //     ? { ...INITIAL_STATE }
      //     : this.props.preEnrollInfo,
      disableCheck: false,
      physicians: this.props.physicians,
      authorizedrelations: this.props.authorizedrelations,
      selectedPlan: "",
      checkName: "",
      capthaVerified:this.props.captcha,
      hrx: "",
    };
    this.validator = new SimpleReactValidator();
  }

  unload = () => {
    console.log("page unloaded");
  };

  async componentDidMount() {
    window.scroll(0, 0);
  if(!isEmpty(this.props.preEnrollInfo)){
    this.setState({
      data:this.props.preEnrollInfo
    })
  }

    window.onbeforeunload = function () {
      return "";
    }.bind(this);
    

    if (this.props.year === "" || this.props.selectedPlan === "") {
      history.push("/webapp/Sharp/Individual/userCreation");
    }
    if (
      (this.props.year === "2022" || this.props.year === "2023") &&
      (this.props.selectedPlan === "SDAGCWD20" ||
        this.props.selectedPlan === "SDAGC20" ||
        this.props.selectedPlan === "SDAPC20" ||
        this.props.selectedPlan === "SDABCWD20")
    ) {
      await this.setState((prevState) => ({
        data: {
          ...prevState.data,
          emailAlert: "N",
        },
      }));
    }
    let data = this.state.data;
    if (data) {
      if (
        data.c1 !== "" ||
        data.c2 !== "" ||
        data.c3 !== "" ||
        data.c4 !== "" ||
        data.c5 !== "" ||
        data.c6 !== "" ||
        data.c7 !== "" ||
        data.c8 !== "" ||
        data.c9 !== "" ||
        data.c10 !== "" ||
        data.c11 !== "" ||
        data.c12 !== "" ||
        data.c13 !== "" ||
        data.c14 !== "" ||
        data.c15 !== "" ||
        data.c16 !== "" ||
        data.c22 !== "" ||
        data.aep !== "" ||
        data.sep !== "" ||
        data.c21 !== "" ||
        data.c20 !== ""
      ) {
        await this.setState({ disableCheck: true });
      }
    }
    await this.setState({ selectedPlan: this.props.selectedPlan });
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.onUnload);
  }

  handleSteps = async (event) => {
    let value = event.target ? event.target.id : event.id;
    if (value) {
      await this.setState({ stepVal: value });

    }
    // if(value==="step2"){
    //   await props.captchaValidation(false)
    // }
  };
  handleDates = async (fieldId) => {
    DateUtil.getDatePicker("#" + fieldId).datepicker("show");
    DateUtil.getDatePicker("#" + fieldId).on("change", (e) => {
      this.setDates(fieldId, e.target.value);
     
    });
    await this.props.captchaValidation(false) 
  };

  setDates = async (fieldId, value) => {
    await this.setState({ data: { ...this.state.data, [fieldId]: value } });
  };
  handleCheckbox2= async (event)=>{
    let name = event.target.name;
    let value = event.target.checked;
    if (name === "mailingAddressRequired") {
      value = event.target.checked ? "YES" : "";
    }
    if (name === "languageCheckSpanish") {
      value = event.target.checked ? "SPANISH" : "";
    }

    if (name === "languageCheckOther") {
      value = event.target.checked ? "OTHER" : "";
    }
    await this.setState({
      data: { ...this.state.data, [name]: value }     
    });

    await this.props.captchaValidation(false) 
  } 
  handleCheckbox = async (event) => {
    let name = event.target.name;
    let value = event.target.checked;
    let save = "";
     
   

    
    if (name === "aep") {
      value = event.target.checked ? "AEP" : "";
      save = name;
    }
    if (name === "sep") {
      value = event.target.checked ? "5ST" : "";
      save = name;
    }
    if (name === "c20") {
      value = event.target.checked ? "OEP" : "";
      save = name;
    }
    
    if (name === "c21") {
      value = event.target.checked ? "OEPN" : "";
      save = name;
    }
    if (name === "c1") {
      value = event.target.checked ? "NEW" : "";
      save = name;
    }
    if (name === "c2") {
      value = event.target.checked ? "MOV" : "";
      save = name;

      if (value === "") {
        await this.setState({ data: { ...this.state.data, attestation2: "" } });
      }
    }
    if (name === "c3") {
      value = event.target.checked ? "INC" : "";
      save = name;
      if (value === "") {
        await this.setState({ data: { ...this.state.data, attestation3: "" } });
      }
    }
    if (name === "c4") {
      value = event.target.checked ? "RUS" : "";
      save = name;
      if (value === "") {
        await this.setState({ data: { ...this.state.data, attestation4: "" } });
      }
    }
    if (name === "c5") {
      value = event.target.checked ? "LAW" : "";
      save = name;
      if (value === "") {
        await this.setState({ data: { ...this.state.data, attestation5: "" } });
      }
    }
    if (name === "c6") {
      value = event.target.checked ? "MDE" : "";
      save = name;
    }
    if (name === "c8") {
      value = event.target.checked ? "NLS" : "";
      save = name;
      if (value === "") {
        await this.setState({ data: { ...this.state.data, attestation8: "" } });
      }
    }
    if (name === "c9") {
      value = event.target.checked ? "LTC" : "";
      save = name;
      if (value === "") {
        await this.setState({ data: { ...this.state.data, attestation9: "" } });
      }
    }
    if (name === "c10") {
      value = event.target.checked ? "PAC" : "";
      save = name;
      if (value === "") {
        await this.setState({
          data: { ...this.state.data, attestation10: "" },
        });
      }
    }
    if (name === "c11") {
      value = event.target.checked ? "LCC" : "";
      save = name;
      if (value === "") {
        await this.setState({
          data: { ...this.state.data, attestation11: "" },
        });
      }
    }
    if (name === "c12") {
      value = event.target.checked ? "LEC" : "";
      save = name;
      if (value === "") {
        await this.setState({
          data: { ...this.state.data, attestation12: "" },
        });
      }
    }
    if (name === "c13") {
      value = event.target.checked ? "PAP" : "";
      save = name;
    }
    if (name === "c14") {
      value = event.target.checked ? "EOC" : "";
      save = name;
    }
    if (name === "c15") {
      value = event.target.checked ? "SNP" : "";
      save = name;
      if (value === "") {
        await this.setState({
          data: { ...this.state.data, attestation15: "" },
        });
      }
    }
    if (name === "c22") {
      value = event.target.checked ? "MCD" : "";
      save = name;
      if (value === "") {
        await this.setState({
          data: { ...this.state.data, recentlyChangeMedicaid: "" },
        });
      }
    }
    if (name === "c23") {
      value = event.target.checked ? "HLP" : "";
      save = name;
      if (value === "") {
        await this.setState({
          data: { ...this.state.data, attestation23: "" },
        });
      }
    }
    if (name === "c25") {
      value = event.target.checked ? "DST" : "";
      save = name;
    }
    if (name === "c7") {
      value = event.target.checked ? "HLP" : "";
      save = name;
      if (value === "") {
        await this.setState({
          data: { ...this.state.data, attestation7: "" },
        });
      }
    }
    if (name === "c16") {
      value = event.target.checked ? "OTH" : "";
      save = name;
      if (value === "") {
        await this.setState({
          data: { ...this.state.data, c16Attestation: "", attestation16: "" },
        });
      }
    }

    await this.setState({
      data: { ...this.state.data, [name]: value },
      checkName: save,
    });

    if (value === "") {
      await this.setState({ disableCheck: false });
    } else {
      await this.setState({ disableCheck: true });
      test = true;
    }
    await this.props.captchaValidation(false)
  };

  submitData = async () => {
    let productId = "";
    let pbpId = "";
    let year=this.props.year
    let selectedPlan = this.state.selectedPlan;
    if (selectedPlan === "SDAGC20") {
      productId = year==="2023"?"IN1I":"IN1G";
      pbpId = "003";
    }
    if (selectedPlan === "SDABCWD20") {
      productId = year==="2023"?"IN3B":"IN3A";
      pbpId = "005";
    }
    if (selectedPlan === "SDAGCWD20") {
      productId =year==="2023"?"IN1J":"IN1H";
      pbpId = "003";
    }
    if (selectedPlan === "SDAPC20") {
      productId = year==="2023"?"IN2F":"IN2E";
      pbpId = "004";
    }
    if (selectedPlan === "SDAB20") {
      productId = year==="2023"?"SH08":"SH06";
      pbpId = "801";
    }
    if (selectedPlan === "SDABWD20") {
      productId = year==="2023"?"SH1E":"SH1C";
      pbpId = "801";
    }
    if (selectedPlan === "SDAP20") {
      productId = year==="2023"?"SH09":"SH07";
      pbpId = "801";
    }
    if (selectedPlan === "SDAPWD20") {
      productId = year==="2023"?"SH2F":"SH2D";
      pbpId = "801";
    }
    if (selectedPlan === "SDAHMO1")  {
      productId = "ME02";
      pbpId = "802";
    }
    if (selectedPlan === "SDAHMO20") {
      productId = "ME03";
      pbpId = "802";
    }
    if (selectedPlan === "SDAHMO200") {
      productId = year==="2023"?"ME05":"ME03";
      pbpId = "801";
    }
    if(this.state.data.mailingAddressRequired === "YES"){
      await this.setState({
        hrx: false,
      });
    }else{
      await this.setState({
        data: { ...this.state.data, mailingState: "" },
      });
    }
    await this.setState({
      data: { ...this.state.data,
        medicareClaim:this.state.data.medicareClaim.slice(0,4)+
        this.state.data.medicareClaim.slice(5,8)+this.state.data.medicareClaim.slice(9) },
    });
    
    let payload = {
      ...this.state.data,
      productId: productId,
      pbpId: pbpId,
      langCode:this.props.lang, 
      ethnicityRace:this.state.data.ethnicityRace.length===1?[]:this.state.data.ethnicityRace   
    };

    if(this.state.data.emailAddr === "" || this.validator.check(this.state.data.emailAddr, "email") ){


      const response = await this.props.submitForm(payload);
       
      if (response.message === "SUCCESS") {
        
        history.push("/webapp/Sharp/Individual/Confirmation");

      } else {
        let msg=this.props.lang==="es"?"Envío fallido":"Submission Failed"
        alert(msg);
      }
    }
    else{
      let msg=this.props.lang==="es"?"Por favor ingrese una dirección de correo electrónico válida":"Please Enter valid Email address"
      alert(msg)
    }

  };

  saveData = async () => {
    let payload={
      ...this.state.data,
      planYear:this.props.year
    }
    const response = await this.props.saveLogout(payload);

    if (response.data === "Enrollment form saved successfully") {
      await this.props.removeplan();
      history.push("/webapp/Sharp/Individual/userCreation");
    } else {
      let msg=this.props.lang==="es"?"Guardar fallida":"Save Failed"
      alert(msg);
    }
  };

  redirect = async (event) => {
    let id = event.target.id;

    if (id === "next2") {
      await this.setState({ stepVal: "step3" });
    }
    if (id === "next1") {
      await this.setState({ stepVal: "step2" });
    }
    if (id === "next3") {
      await this.setState({ stepVal: "step4" });
    }
    if (id === "next4") {
      await this.setState({ stepVal: "step1" });
    }
  };
  formatPhoneNumber = (phoneNumberString) => {
    var match = phoneNumberString.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return "(" + match[1] + ") " + match[2] + "-" + match[3];
    }
    return phoneNumberString;
  };
  handleNumberChange = async(event) => {
    let name = event.target.name;
    let value = event.target.value;
    value = value.replace(/[^0-9]/g, "");

    this.setState({ data: { ...this.state.data, [name]: value } });
    await this.props.captchaValidation(false)
  };

  handleDate = async (event) => {
    let name = event.target.name;
    let value = event.target.value;
    value = handleDateChange(value);
    await this.setState({
      data: { ...this.state.data, [name]: value },
    });
    await this.props.captchaValidation(false) 
  };
  handleChange = async(event) => {
    let name = event.target.name;
    let value = event.target.value;
     
    if (name.toLowerCase().includes("phone")) {
      value = this.formatPhoneNumber(value.replace(/[^0-9]/g, ""));
    }

    if (event.target.type === "checkbox" && (name !== "language" || name !== "languageCheck")) {
      value = event.target.checked ? "Y" : "N";
    }

    if (name === "renalDisease" && value === "N") {
      this.setState({
        data: { ...this.state.data, [name]: value, esrdcontact: "" },
      });
      return;
    }

    if (name === "medicareClaim") {
      let c=0
      
     if(value.includes("-") || value.length>11){
      value=value.replace(/-/g,'')
      value = value.slice(0, 11)
     }
      if(value.length===11 && value.indexOf("-")===-1){
        value=value.slice(0, 4)+"-"+value.slice(4, 7)+"-"+value.slice(7);
      }
      let check=value.replace(/-/g,'')
      if(check.length<11){
        value=check
      }
      for(let i=0;i<value.length;i++){
        if(value[i]==="-"){
          c=c+1
        }
      }
      if(check.length===11 && c<2){
        value=check;
        value=value.slice(0, 4)+"-"+value.slice(4, 7)+"-"+value.slice(7);
      }
      value=value.toUpperCase()
    }

    if (name === "vaBenefits" && value === "N") {
      this.setState({
        data: {
          ...this.state.data,
          [name]: value,
          nameOfCov: "",
          idOfCov: "",
          groupOfCov: "",
        },
      });
      return;
    }

    if (name === "medicaidprg" && value === "N") {
      this.setState({
        data: { ...this.state.data, [name]: value, medicaidNbr: "" },
      });
      return;
    }
    if (name === "prescriptionDrug" && value === "N") {
      this.setState({
        data: {
          ...this.state.data,
          [name]: value,
          nameOfInst: "",
          phoneOfInst: "",
          addrOfInst: "",
        },
      });
      return;
    }
    if (name === "retiree" && value === "N") {
      this.setState({
        data: {
          ...this.state.data,
          [name]: value,
          retiredate: "",
          coveringSpouseOrDependent: "",
          coveringSpouseOrDependentEmployeeName: "",
          coveringSpouseOrDependentMiddleName: "",
          coveringSpouseOrDependentFirstName: "",
          coveringSpouseOrDependentLastName: "",
        },
      });
      return;
    }
    if (name === "retiree" && value === "Y") {
      this.setState({
        data: {
          ...this.state.data,
          [name]: value,
          retirename: "",
          survivingSpouseCitySanDiegoRetiree: "",
          survivingSpouseCitySanDiegoRetireeLastName: "",
          survivingSpouseCitySanDiegoRetireeFirstName: "",
          survivingSpouseCitySanDiegoRetireeMiddleName: "",
        },
      });
      return;
    }

    if (name === "coveringSpouseOrDependent" && value === "Y") {
      this.setState({
        data: {
          ...this.state.data,
          [name]: value,
          coveringSpouseOrDependentEmployeeName: "",
        },
      });
      return;
    }
    if (name === "coveringSpouseOrDependent" && value === "N") {
      this.setState({
        data: {
          ...this.state.data,
          [name]: value,
          coveringSpouseOrDependentMiddleName: "",
          coveringSpouseOrDependentFirstName: "",
          coveringSpouseOrDependentLastName: "",
        },
      });
      return;
    }
    if (name === "coveringSpouseOrDependentEmployeeName" && value === "N") {
      this.setState({
        data: {
          ...this.state.data,
          [name]: value,
          survivingSpouseCitySanDiegoRetireeLastName: "",
          survivingSpouseCitySanDiegoRetireeFirstName: "",
          survivingSpouseCitySanDiegoRetireeMiddleName: "",
        },
      });
      return;
    }
    if ((name === "empCover" || name === "meddependsp") && value === "N") {
      this.setState({
        data: {
          ...this.state.data,
          [name]: value,
          dependentSpouse: "",
          dependentOther: "",
        },
      });
      return;
    }
   await  this.setState({ data: { ...this.state.data, [name]: value } });
   await this.props.captchaValidation(false)
  };
  handleStepCheckbox=async(event)=>{
    let value = event.target.value
    let name= event.target.name
    let ethnicity1 = this.state.data.ethnicityRace
    if(ethnicity1.some((item)=> item.piValue===value)){
      ethnicity1 = ethnicity1.filter(item => item.piValue!==value)          
    }else{
      if(ethnicity1.some((item)=> item.piValue==="999") && name ==="RACE"){
        return;
      }
      if(ethnicity1.some((item)=> item.piValue==="NR") && name ==="ETHNICITY"){
        return;
      }
    ethnicity1.push({"piCode":name,"piValue":value})
    if(value==="999" && name ==="RACE"){
      ethnicity1 = ethnicity1.filter((item)=> item.piValue===value || item.piCode==="ETHNICITY")
     }
     if(value==="NR" && name === "ETHNICITY"){
       ethnicity1 = ethnicity1.filter((item)=> item.piValue===value || item.piCode==="RACE")
     }
    }
  
    console.log(ethnicity1)
   
    await this.setState({
      data: { ...this.state.data, ethnicityRace:ethnicity1}
    })
  }
  getLabel=(value)=>{
    let obj=this.props.physicians;    
  let label = obj.find(el => el.value === value);  
 

  return label.label
  }
  pcpChange = async (event) => {
    const name = event.target.name;
    const value = event.target.value;
    const plan = this.state.selectedPlan;
  let label= await this.getLabel(value)
    if (plan !== "SDAHMO1" && plan !=="SDAHMO20" ) {
      const data = await this.props.getClinicalName(value);
      this.setState({
        data: {
          ...this.state.data,
          [name]: value,
          pcpMedicalGroupName: data.data,
          pcpNameLabel:label
        },
      });
    } else {
      this.setState({
        data: {
          ...this.state.data,
          [name]: value,
        },
      });
    }
    await this.props.captchaValidation(false)
  };
  setRuLanguage = async () => {
    if (lang === "en") {
      await setLanguage("es");
      lang = "es";
    } else {
      await setLanguage("en");
      lang = "en";
    }
  };
  render() {
   
    const { data, selectedPlan } = this.state;
    let count = "";
    let progress = "";
    if (
      (this.props.year === "2022" || this.props.year === "2023")&&
      (this.props.selectedPlan === "SDAGCWD20" ||
        this.props.selectedPlan === "SDAGC20" ||
        this.props.selectedPlan === "SDAPC20"||
        this.props.selectedPlan === "SDABCWD20" ||
        this.props.selectedPlan==="SDAHMO20" ||
        this.props.selectedPlan==="SDAHMO200")
    ) {
       count =this.state.data.mailingAddressRequired === "YES"?data.vaBenefits === "Y"? 35 :32:data.vaBenefits === "Y"?32:29;
       let progress32,progress33,progress34
       if(this.state.data.mailingAddressRequired === "YES"){
         progress32 = data.mailingCity === "" ? 0 : 1;
        progress33 = data.mailingAddr === "" ? 0 : 1;
        progress34 = data.mailingzip === "" ? 0 : 1;
       }
      const progress1 = data.firstName === "" ? 0 : 1;
      const progress2 = data.lastName === "" ? 0 : 1;
      const progress3 =
        data.birthDate === "" ||
        !moment(data.birthDate, "MM/DD/YYYY", true).isValid()
          ? 0
          : 1;
      
      const progress4 = data.primaryPhone === "" ? 0 : 1;
      const progress5 = data.permanentAddrStreet === "" ? 0 : 1;
      const progress6 = data.permanentCity === "" ? 0 : 1;

      // const progress7 =
      //   data.emailAddr === "" ||
      //   !this.validator.check(data.emailAddr, "email") ||
      //   !data.emailAddr.endsWith(".com")
      //     ? 0
      //     : 1;

      // const progress7 =
      //   (!this.validator.check(data.emailAddr, "email")||
      //   !data.emailAddr.endsWith(".com") ) &&
      //   data.emailAddr == ""
      //     ? 0
      //     : 1;
      const progress7 = data.permanentZip === "" ? 0 : 1;
      const progress8 = data.sex === "" ? 0 : 1;
      const progress9 = data.medicareClaim === "" || data.medicareClaim?.length<11? 0 : 1;
      const progress10 = data.pcpName === "" ? 0 : 1;
      const progress11 = data.pcpMedicalGroupName === "" ? 0 : 1;
      const progress12 = data.nameSignature === "" ? 0 : 1;

      const progress13 =
        data.AuthorizedRep === "Y" && data.authorizedrepname !== "" ? 1 : 0;
      const progress14 =
        data.AuthorizedRep === "Y" && data.authorizedreprelationship !== ""
          ? 1
          : 0;
      const progress15 =
        data.AuthorizedRep === "Y" && data.authorizedrepaddress !== "" ? 1 : 0;
      const progress16 =
        data.AuthorizedRep === "Y" && data.authorizedrepphone !== "" ? 1 : 0;
      const progress17 =
        data.AgentAssistingEnrollment === "Y" && data.nameAgent !== "" ? 1 : 0;
      const progress35 = data.vaBenefits === "Y" && data.nameOfCov !==""?1:0;
      const progress36 = data.vaBenefits === "Y" && data.idOfCov !==""?1:0;
      const progress37 = data.vaBenefits === "Y" && data.groupOfCov !==""?1:0;
      const progress18 = data.c2 === "MOV" && data.attestation2 !== "" ? 1 : 0;
      const progress19 = data.c3 === "INC" && data.attestation3 !== "" ? 1 : 0;
      const progress20 = data.c4 === "RUS" && data.attestation4 !== "" ? 1 : 0;
      const progress21 = data.c5 === "LAW" && data.attestation5 !== "" ? 1 : 0;
      const progress22 = data.c8 === "NLS" && data.attestation8 !== "" ? 1 : 0;
      const progress23 = data.c9 === "LTC" && data.attestation9 !== "" ? 1 : 0;
      const progress24 =
        data.c10 === "PAC" && data.attestation10 !== "" ? 1 : 0;
      const progress25 =
        data.c11 === "LCC" && data.attestation11 !== "" ? 1 : 0;
      const progress26 =
        data.c12 === "LEC" && data.attestation12 !== "" ? 1 : 0;
      const progress27 =
        data.c15 === "SNP" && data.attestation15 !== "" ? 1 : 0;
      const progress28 =
        data.c22 === "MCD" && data.recentlyChangeMedicaid !== "" ? 1 : 0;
      //const progress29 = data.c7 === "HLP" && data.attestation7;
      if (
        (data.attestation2 === "" ||
          !moment(data.attestation2, "MM/DD/YYYY", true).isValid()) &&
        (data.attestation3 === "" ||
          !moment(data.attestation3, "MM/DD/YYYY", true).isValid()) &&
        (data.attestation4 === "" ||
          !moment(data.attestation4, "MM/DD/YYYY", true).isValid()) &&
        (data.attestation5 === "" ||
          !moment(data.attestation5, "MM/DD/YYYY", true).isValid()) &&
        (data.attestation8 === "" ||
          !moment(data.attestation8, "MM/DD/YYYY", true).isValid()) &&
        (data.attestation9 === "" ||
          !moment(data.attestation9, "MM/DD/YYYY", true).isValid()) &&
        (data.attestation10 === "" ||
          !moment(data.attestation10, "MM/DD/YYYY", true).isValid()) &&
        (data.attestation11 === "" ||
          !moment(data.attestation11, "MM/DD/YYYY", true).isValid()) &&
        (data.attestation12 === "" ||
          !moment(data.attestation12, "MM/DD/YYYY", true).isValid()) &&
        (data.attestation15 === "" ||
          !moment(data.attestation15, "MM/DD/YYYY", true).isValid()) &&
        (data.recentlyChangeMedicaid === "" ||
          !moment(data.recentlyChangeMedicaid, "MM/DD/YYYY", true).isValid()) &&
        (data.attestation7 === "" ||
          !moment(data.attestation7, "MM/DD/YYYY", true).isValid())
      ) {
        count -= 12;
      } else {
        count -= 11;
      }
      if (data.AuthorizedRep !== "Y") count -= 4;
      if (data.AgentAssistingEnrollment !== "Y") count -= 1;
     progress =
        ((progress1 +
          progress2 +
          progress3 +
          progress4 +
          progress5 +
          progress6 +
          progress7 +
          progress8 +
          progress9 +
          progress10 +
          progress11 +
          progress12 +
          progress13 +
          progress14 +
          progress15 +
          progress16 +
          progress17 +
          progress18 +
          progress19 +
          progress20 +
          progress21 +
          progress22 +
          progress23 +
          progress24 +
          progress25 +
          progress26 +
          progress27 +
          progress28 +
         // progress29 +
         (data.vaBenefits === "Y"?progress35 +
         progress36 +
         progress37 :0)+
          (this.state.data.mailingAddressRequired === "YES"?
          progress32+
          progress33+
          progress34:0)) /
          count) *
        100;      
    } else {
       count = this.props.selectedPlan !== "SDAHMO1" && this.props.selectedPlan !== "SDAHMO20" && this.props.selectedPlan !== "SDAHMO200"?34:32;
        
        let progress32,progress33;
        if(this.props.selectedPlan !== "SDAHMO1" &&  this.props.selectedPlan !== "SDAHMO20" && this.props.selectedPlan !== "SDAHMO200"){
          progress32 = data.effDate === "" ||
          !moment(data.effDate, "MM/DD/YYYY", true).isValid()
            ? 0
            : 1;
          progress33 = data.ssn.length !=9 ? 0 : 1;
          
        }
      const progress1 = data.firstName === "" ? 0 : 1;
      const progress2 = data.lastName === "" ? 0 : 1;
      const progress3 =
        data.birthDate === "" ||
        !moment(data.birthDate, "MM/DD/YYYY", true).isValid()
          ? 0
          : 1;
      const progress4 = data.primaryPhone === "" ? 0 : 1;
      const progress5 = data.permanentAddrStreet === "" ? 0 : 1;
      const progress6 = data.permanentCity === "" ? 0 : 1;
      // const progress7 = data.emailAddr === "" ? 0 : 1;
      const progress7 = data.permanentZip === "" ? 0 : 1;
      const progress8 = data.sex === "" ? 0 : 1;
      const progress9 = data.medicareClaim === "" || data.medicareClaim?.length<11? 0 : 1;

      const progress10 =
        data.hospitalPartA === "" ||
        !moment(data.hospitalPartA, "MM/DD/YYYY", true).isValid()
          ? 0
          : 1;
      const progress11 =
        data.hospitalPartB === "" ||
        !moment(data.hospitalPartB, "MM/DD/YYYY", true).isValid()
          ? 0
          : 1;

      const progress12 = data.pcpName === "" ? 0 : 1;
      const progress13 = data.nameSignature === "" ? 0 : 1;

      const progress14 =
        data.AuthorizedRep === "Y" && data.authorizedrepname !== "" ? 1 : 0;
      const progress15 =
        data.AuthorizedRep === "Y" && data.authorizedreprelationship !== ""
          ? 1
          : 0;
      const progress16 =
        data.AuthorizedRep === "Y" && data.authorizedrepaddress !== "" ? 1 : 0;
      const progress17 =
        data.AuthorizedRep === "Y" && data.authorizedrepphone !== "" ? 1 : 0;
      const progress18 =
        data.AgentAssistingEnrollment === "Y" && data.nameAgent !== "" ? 1 : 0;
        const progress35 = data.vaBenefits === "Y" && data.nameOfCov !==""?1:0;
        const progress36 = data.vaBenefits === "Y" && data.idOfCov !==""?1:0;
        const progress37 = data.vaBenefits === "Y" && data.groupOfCov !==""?1:0;
      const progress19 = data.c2 === "MOV" && data.attestation2 !== "" ? 1 : 0;
      const progress20 = data.c3 === "INC" && data.attestation3 !== "" ? 1 : 0;
      const progress21 = data.c4 === "RUS" && data.attestation4 !== "" ? 1 : 0;
      const progress22 = data.c5 === "LAW" && data.attestation5 !== "" ? 1 : 0;
      const progress23 = data.c8 === "NLS" && data.attestation8 !== "" ? 1 : 0;
      const progress24 = data.c9 === "LTC" && data.attestation9 !== "" ? 1 : 0;
      const progress25 =
        data.c10 === "PAC" && data.attestation10 !== "" ? 1 : 0;

      const progress26 =
        data.c11 === "LCC" && data.attestation11 !== "" ? 1 : 0;
      const progress27 =
        data.c12 === "LEC" && data.attestation12 !== "" ? 1 : 0;
      const progress28 =
        data.c15 === "SNP" && data.attestation15 !== "" ? 1 : 0;
      const progress29 =
        data.c16 === "OTH" &&
        (data.c16Attestation !== "" || data.attestation16 !== "")
          ? 1
          : 0;
      if (
        (data.attestation2 === "" ||
          !moment(data.attestation2, "MM/DD/YYYY", true).isValid()) &&
        (data.attestation3 === "" ||
          !moment(data.attestation3, "MM/DD/YYYY", true).isValid()) &&
        (data.attestation4 === "" ||
          !moment(data.attestation4, "MM/DD/YYYY", true).isValid()) &&
        (data.attestation5 === "" ||
          !moment(data.attestation5, "MM/DD/YYYY", true).isValid()) &&
        (data.attestation8 === "" ||
          !moment(data.attestation8, "MM/DD/YYYY", true).isValid()) &&
        (data.attestation9 === "" ||
          !moment(data.attestation9, "MM/DD/YYYY", true).isValid()) &&
        (data.attestation10 === "" ||
          !moment(data.attestation10, "MM/DD/YYYY", true).isValid()) &&
        (data.attestation11 === "" ||
          !moment(data.attestation11, "MM/DD/YYYY", true).isValid()) &&
        (data.attestation12 === "" ||
          !moment(data.attestation12, "MM/DD/YYYY", true).isValid()) &&
        data.attestation15 === "" &&
        (data.c16Attestation === "" ||
          !moment(data.attestation16, "MM/DD/YYYY", true).isValid())
      ) {
        count -= 11;
      } else {
        count -= 10;
      }
      if (data.AuthorizedRep !== "Y") count -= 4;
      if (data.AgentAssistingEnrollment !== "Y") count -= 1;
      if(data.vaBenefits!=="Y")count-=3;
      // if(
      //   selectedPlan === "SDAB20" ||
      //   selectedPlan === "SDABWD20" ||
      //   selectedPlan === "SDAP20" ||
      //   selectedPlan === "SDAPWD20" ||
      //   selectedPlan === "SDAHMO1" ||
      //   selectedPlan === "SDAHMO20"
      // ){
      //   count +=1;
      //   if(data.effDate === "" ||
      //   !moment(data.effDate, "MM/DD/YYYY", true).isValid()){
      //     count-=1;
      //   }
      // }


      progress =
        ((progress1 +
          progress2 +
          progress3 +
          progress4 +
          progress5 +
          progress6 +
          progress7 +
          progress8 +
          progress9 +
          progress10 +
          progress11 +
          progress12 +
          progress13 +
          progress14 +
          progress15 +
          progress16 +
          progress17 +
          progress18 +
          progress19 +
          progress20 +
          progress21 +
          progress22 +
          progress23 +
          progress24 +
          progress25 +
          progress26 +
          progress27 +
          progress28 +
          progress29 +
          progress35 +
          progress36 +
          progress37 +
          (this.props.selectedPlan !== "SDAHMO1" && this.props.selectedPlan !== "SDAHMO20" && this.props.selectedPlan !== "SDAHMO200"?
          progress32+
          progress33:0)) /
          count) *
        100;

  
    }
    //Category1 : Plans of ---> Open to all Medicare-eligible residents of San Diego County
    //Category2 : Plans of ---> Former Employees of Sharp HealthCare only
    //Category3 : Plans of ---> Retirees of the City of San Diego (SDPEBA) only
    let Step2 = "";
    if (
      (this.props.year === "2022"|| this.props.year === "2023")&&
      (this.props.selectedPlan === "SDAGCWD20" ||
        this.props.selectedPlan === "SDAGC20" ||
        this.props.selectedPlan === "SDAPC20"||
        this.props.selectedPlan === "SDABCWD20")
       
    ) {
      Step2 = Step2_2021;
    } else {
      Step2 = Step2Category1;
      if (
        selectedPlan === "SDAB20" ||
        selectedPlan === "SDABWD20" ||
        selectedPlan === "SDAP20" ||
        selectedPlan === "SDAPWD20"
      ) {
        Step2 = Step2Category2;
      }

      if (selectedPlan === "SDAHMO1" || selectedPlan === "SDAHMO20" || selectedPlan === "SDAHMO200") {
        Step2 = Step2Category3;
      }
    }

    if (selectedPlan === "SDAHMO1" || selectedPlan === "SDAHMO20" || selectedPlan === "SDAHMO200") {
      Step2 = Step2Category3;
    }

    const { checkName } = this.state;
    if (
      (this.props.year === "2022" || this.props.year === "2023")&&
      (this.props.selectedPlan === "SDAGCWD20" ||
        this.props.selectedPlan === "SDAGC20" ||
        this.props.selectedPlan === "SDAPC20"||
        this.props.selectedPlan === "SDABCWD20")
    ) {
      test = this.state.disableCheck
        ? checkName === "aep" ||
        checkName === "sep" ||
          checkName === "c1" ||
          checkName === "c6" ||
          checkName === "c7" ||
          checkName === "c13" ||
          checkName === "c14" ||
          checkName === "c25" ||
          checkName === "c21"  ||
          checkName ==="c20"
          ? false
          : data.attestation2 !== "" ||
            data.attestation3 !== "" ||
            data.attestation4 !== "" ||
            data.attestation5 !== "" ||
            data.attestation8 !== "" ||
            data.attestation9 !== "" ||
            data.attestation10 !== "" ||
            data.attestation11 !== "" ||
            data.attestation12 !== "" ||
            data.attestation15 !== "" ||
            data.c16Attestation !== "" ||
            data.attestation16 !== "" ||
            data.recentlyChangeMedicaid != "" ||
            data.attestation23 != ""
          ? false
          : true
        : false;
    } else {
      test = this.state.disableCheck
        ? checkName === "aep" ||
        checkName === "sep" ||
          checkName === "c1" ||
          checkName === "c6" ||
          checkName === "c7" ||
          checkName === "c13" ||
          checkName == "c14"  ||
          checkName ==="c21" ||
          checkName ==="c20"||
          checkName ==="c25"
          ? false
          : data.attestation2 !== "" ||
            data.attestation3 !== "" ||
            data.attestation4 !== "" ||
            data.attestation5 !== "" ||
            data.attestation8 !== "" ||
            data.attestation9 !== "" ||
            data.attestation10 !== "" ||
            data.attestation11 !== "" ||
            data.attestation12 !== "" ||
            data.attestation15 !== "" ||
            data.c16Attestation !== "" ||
            data.attestation16 !== ""
          ? false
          : true
        : false;
    }

    return (
     
      <React.Fragment>
          
    
        <div class="background">
          <CUSTOMER_LOGO />
          <div class="container mt-3">
            <div class="progress-bar">
              <LinearProgress
                variant="determinate"
                value={progress}
                color="primary"
                classes={{
                  root: this.props.classes.root,
                  barColorPrimary:
                    progress === 100
                      ? this.props.classes.progressComplete
                      : this.props.classes.progressIncomplete,
                }}
              />
            </div>

            <ul
              class="nav nav-pills nav-justified"
              value={this.state.stepVal}
              onClick={this.handleSteps}
            >
              <li class="nav-item">
                <p
                  class={
                    this.state.stepVal === "step1"
                      ? "nav-link active"
                      : "nav-link"
                  }
                  data-toggle="tab"
                  id="step1"
                  style={{padding:".1rem 1rem"}}
                >
                  <Text id="app.Step"/> 1
                </p>
              </li>
              <li class="nav-item">
                <p
                  class={
                    this.state.stepVal === "step2"
                      ? "nav-link active"
                      : "nav-link"
                  }
                  data-toggle="tab"
                  id="step2"
                  style={{padding:".1rem 1rem"}}
                >
                 <Text id="app.Step"/> 2
                </p>
              </li>
              <li class="nav-item">
                <p
                  class={
                    this.state.stepVal === "step3"
                      ? "nav-link active"
                      : "nav-link"
                  }
                  data-toggle="tab"
                  id="step3"
                  style={{padding:".1rem 1rem"}}
                >
                 <Text id="app.Step"/> 3
                </p>
              </li>
              {!(
                ( this.props.year == "2022"  ||  this.props.year === "2023") &&
                (this.props.selectedPlan === "SDAGCWD20" ||
                  this.props.selectedPlan === "SDAGC20" ||
                  this.props.selectedPlan === "SDAPC20"||
                  this.props.selectedPlan === "SDABCWD20"||
                  this.props.selectedPlan === "SDAB20"||
                  this.props.selectedPlan === "SDABWD20"||
                  this.props.selectedPlan === "SDAP20"||
                  this.props.selectedPlan === "SDAPWD20")||
                  this.props.year === "2021" &&
                (this.props.selectedPlan === "SDAGCWD20" ||
                  this.props.selectedPlan === "SDAGC20" ||
                  this.props.selectedPlan === "SDAPC20"
                  )
              ) ? (
                <li class="nav-item">
                  <p
                    class={
                      this.state.stepVal === "step4"
                        ? "nav-link active"
                        : "nav-link"
                    }
                    data-toggle="tab"
                    id="step4"
                    style={{padding:".1rem 1rem"}}
                  >
                    <Text id="app.Step"/> 4
                  </p>
                </li>
              ) : null}
            </ul>

            {this.state.stepVal === "step1" && (
              <Step1
                selectedPlan={this.props.selectedPlan}
                data={this.state.data}
                handleNumberChange={this.handleNumberChange}
                authorizedrelations={this.props.authorizedrelations}
                handleChange={this.handleChange}
                redirect={this.redirect}
                handleDates={this.handleDates}
                handleDate={this.handleDate}
                handleCheckbox={this.handleCheckbox}
                handleCheckbox2={this.handleCheckbox2}
                handleStepCheckbox={this.handleStepCheckbox}
              />
            )}
            {this.state.stepVal === "step2" && (
              <Step2
                selectedPlan={this.props.selectedPlan}
                data={this.state.data}
                handleChange={this.handleChange}
                handleStepCheckbox={this.handleStepCheckbox}
                handleNumberChange={this.handleNumberChange}
                pcpChange={this.pcpChange}
                physicians={this.state.physicians}
                redirect={this.redirect}
                handleDates={this.handleDates}
                handleDate={this.handleDate}
                handleCheckbox={this.handleCheckbox}
                handleCheckbox2={this.handleCheckbox2}
              />
            )}
            {this.state.stepVal === "step3" && (
              <Step3
                selectedPlan={this.props.selectedPlan}
                data={this.state.data}
                handleCheckbox={this.handleCheckbox}
                redirect={this.redirect}
                disableCheck={this.state.disableCheck}
                handleChange={this.handleChange}
                handleDates={this.handleDates}
                handleDate={this.handleDate}
                handleStepCheckbox={this.handleStepCheckbox}
              />
            )}
            {!(
              (this.props.year == "2022" || this.props.year === "2023") &&
              (this.props.selectedPlan === "SDAGCWD20" ||
                this.props.selectedPlan === "SDAGC20" ||
                this.props.selectedPlan === "SDAPC20"||
                this.props.selectedPlan === "SDABCWD20"||
                this.props.selectedPlan === "SDAB20"||
                  this.props.selectedPlan === "SDABWD20"||
                  this.props.selectedPlan === "SDAP20"||
                  this.props.selectedPlan === "SDAPWD20")
            ) &&
              this.state.stepVal === "step4" && (
                <Step4
                  selectedPlan={this.props.selectedPlan}
                  data={this.state.data}
                  handleChange={this.handleChange}
                  redirect={this.redirect}
                  authorizedrelations={this.props.authorizedrelations}
                  handleDates={this.handleDates}
                  handleDate={this.handleDate}
                />
              )}

            <div class="row" style={{ marginTop: "0.9rem" }}>
              <div class="col-md-2">
                {!this.props.guestLogin ? (
                  <button
                    class="btn btn-SaveLogout"
                    id="submit"
                    onClick={this.saveData}
                  >
                    <Text id="app.save" />
                  </button>
                ) : null}
              </div>
              {console.log(progress  , "   " , test  ,"   ", this.props.captcha )}
              {console.log(!(progress === 100 && !test) || !this.props.captcha )}
              {console.log(progress === 100  , "   " , !test  ,"   ",!this.props.captcha)}
              <div class="col-md-8">
                {!(progress === 100 && !test) || !this.props.captcha ? (
                  <span
                    class="small text-danger"
                    style={{ fontSize: "15px !important" }}
                  >
                    <strong>
                      <Text id="app.error1" />
                      {!(
                       ( this.props.year === "2022" || this.props.year === "2023"&&
                        (this.props.selectedPlan === "SDAGCWD20" ||
                          this.props.selectedPlan === "SDAGC20" ||
                          this.props.selectedPlan === "SDAPC20"||
                          this.props.selectedPlan === "SDABCWD20"||
                          this.props.selectedPlan === "SDAB20"||
                          this.props.selectedPlan === "SDABWD20"||
                          this.props.selectedPlan === "SDAP20"||
                          this.props.selectedPlan === "SDAPWD20"))||
                         ( this.props.year === "2021" &&
                        (this.props.selectedPlan === "SDAGCWD20" ||
                          this.props.selectedPlan === "SDAGC20" ||
                          this.props.selectedPlan === "SDAPC20"
                         ))
                      )
                        ? " steps 1-4 "
                        : " steps 1-3 "}
                      <Text id="app.error2" /> .
                    </strong>
                  </span>
                ) : (
                  <span class="small text-success">
                    <strong>
                      <Text id="app.cong" />.
                    </strong>
                  </span>
                )}
              </div>
              
                  {                  
                    (progress === 100 && !test && !this.props.captcha)?
                      
                      // (((this.props.year === "2021" || this.props.year === "2022") &&
                      // (this.props.selectedPlan === "SDAGCWD20" || this.props.selectedPlan === "SDAGC20" ||
                      //   this.props.selectedPlan === "SDAPC20"|| this.props.selectedPlan === "SDABCWD20") && (this.state.stepVal === "step3")) ||
                      // (this.props.year === "2021" && (
                      //   this.props.selectedPlan === "SDAB20"||
                      //   this.props.selectedPlan === "SDABWD20"||
                      //   this.props.selectedPlan === "SDAP20"||
                      //   this.props.selectedPlan === "SDAPWD20") && this.state.stepVal === "step4") ||
                      // (

                      //   this.props.year === "2022" && (
                      //     this.props.selectedPlan === "SDAB20"||
                      //     this.props.selectedPlan === "SDABWD20"||
                      //     this.props.selectedPlan === "SDAP20"||
                      //     this.props.selectedPlan === "SDAPWD20") && this.state.stepVal === "step3") ||
                      // (
                      //   this.props.year === "2021" && this.props.selectedPlan === "SDAHMO20" && this.state.stepVal === "step4") ||
                      // (
                      //   this.props.year === "2022" && this.props.selectedPlan === "SDAHMO20" && this.state.stepVal === "step4"
                      // ))
                
                     
                      <Captcha/>:null
                     //:null
                  }
              
              <div class="col-md-2">
                <button
                  class={
                    progress === 100 && !test && this.props.captcha
                      ? "btn btn-primary float-right"
                      : "btn btn-secondary float-right"
                  }
                  id="submit"
                  onClick={this.submitData}
                  disabled={!(progress === 100 && !test && this.props.captcha)}

                >
                  <Text id="app.submit" />
                </button>
              </div>
            </div>
            {/* {this.props.year === "2021" ? (
              <div class="row" style={{ marginTop: "0.9rem" }}>
                <div class="col-md-2">
                  <button
                    class="btn btn-SaveLogout"
                    id="language"
                    onClick={this.setRuLanguage}
                  >
                   <Text id="app.lang"/>
                  </button>
                </div>
              </div>
          ) : null} */}

            {/* {this.props.progress !== 100 ? (
                <span
                  class="small text-danger"
                  style={{ fontSize: "15px !important" }}
                >
                  <strong>
                    We're missing a few pieces of information. Please check
                    steps 1-3 for red highlighted fields. When all required
                    information has been entered, the submit button will display
                    in green.
                  </strong>
                </span>
              ) : (
                <span class="small text-success">
                  <strong>
                    Congratulations! Your Medicare form is complete, please
                    press SUBMIT to finish.
                  </strong>
                </span>
              )}

              <button
                class={
                  progress === 100
                    ? "btn btn-primary float-right"
                    : "btn btn-secondary float-right"
                }
                id="submit"
                onClick={this.submitData}
                disabled={progress !== 100}
              >
                Submit
              </button> */}

            <br />
            {selectedPlan === "SDAGCWD20" ||
            selectedPlan === "SDAGC20" ||
            selectedPlan === "SDABCWD20"||
            selectedPlan === "SDAPC20" ? (
              <p style={{ float: "left", marginTop: "20px" }}>
                <strong>
                  H5386_{this.props.year} {this.props.year==="2023"?<Text id="app.online1" />
                          :<Text id="app.online" />}
                </strong>
              </p>
            ) :(this.props.year==="2022" || this.props.year==="2023" && selectedPlan === "SDAB20" ||
              selectedPlan === "SDABWD20" ||
              selectedPlan === "SDAP20" ||
              selectedPlan === "SDAPWD20"||
              selectedPlan === "SDAHMO200") ? (
              <div>
                <p style={{ float: "left", marginTop: "20px" }}>
                  <strong>
                    H5386_EGWP <Text id="app.enroll" />
                  </strong>
                </p>
              </div>
            ) : (
              <div class="col-md-3"></div>
            )}
            {(this.props.year==="2021") && (selectedPlan==="SDAB20"|| 
            selectedPlan==="SDABWD20"|| 
            selectedPlan==="SDAP20"||
            selectedPlan==="SDAPWD20")?(
               <div>
                <p style={{ float: "left", marginTop: "20px" }}>
                  <strong>
                    H5386_{this.props.year} <Text id="app.enroll1" />
                  </strong>
                </p>
              </div>
            ):null}
 {(this.props.year==="2022" ||this.props.year==="2023")?
      <div style={{marginTop:"5rem",textAlign:"left"}}>
     
      <Text id="app.newfooter"/>
       
     </div>
     :null}
            <StepsFooter />
          </div>
          {
            <Footer1 />
          }
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    year: state.webApp.year,
    preEnrollInfo: state.webApp.preEnrollInfo,
    guestLogin: state.webApp.guestLogin,
    physicians: state.webApp.physicians,
    authorizedrelations: state.webApp.authorizedrelations,
    selectedPlan: state.webApp.selectedPlan,
    lang: state.webApp.language,
    captcha:state.webApp.Captcha
  };
};
const mapDispatchToProps = {
  saveLogout,
  submitForm,
  getClinicalName,
  removeplan,
  captchaValidation
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(PreEnrollForm));
